const common = {
  nav: {
    getUmiGo: 'Get UmiGo',
    downloadTitle: 'Download UmiGo',
    apkDownload: 'APK Download',
    apkDesc: 'Direct install',
    googlePlay: 'Google Play',
    googlePlayDesc: 'Android devices',
    appStore: 'App Store',
    appStoreDesc: 'iOS devices',
  },
  hero: {
    title1: 'UmiGo',
    title2: 'Your World',
    title3: 'Social',
    subtitle: 'Chat, play and connect with your family in one app',
    watchDemo: 'Watch Demo',
  },
  features: {
    title: 'Everything',
    titleLine2: 'you need',
    subtitle: 'Discover the features that make UmiGo your favorite app',
    voiceChat: 'Voice Chat',
    voiceChatDesc: 'Join real-time voice rooms with crystal-clear quality. Connect with friends and family across LATAM with zero lag.',
    liveVideo: 'Live Video',
    liveVideoDesc: 'Face-to-face video calls with up to 12 people simultaneously',
    miniGames: 'Mini Games',
    miniGamesTag: '50+ games',
    miniGamesDesc: 'Play together with friends in our collection of fun mini games',
    familySpaces: 'Family Spaces',
    familySpacesDesc: 'Create private family groups with shared calendars, photos, and memories',
    instantMessaging: 'Instant Messaging',
    instantMessagingDesc: 'Send text, voice messages, photos, and videos with end-to-end encryption',
    virtualGifts: 'Virtual Gifts',
    virtualGiftsDesc: 'Send fun virtual gifts and stickers to express yourself in conversations',
  },
  about: {
    tag: 'Our Community',
    imageTitle1: 'More than',
    imageTitle2: 'an app',
    imageTitle3: 'a family',
    title: 'Connect with',
    titleLine2: 'who matters most',
    paragraph1: 'UmiGo was born from a simple idea: bringing Latin American families and friends closer together, no matter the distance. We understand the importance of staying connected with your loved ones.',
    paragraph2: 'Our platform combines the best of social networking, entertainment, and communication tools designed specifically for the LATAM community. From voice chats to mini games, every feature is crafted to create meaningful connections.',
    paragraph3: 'Join millions of users across Latin America who have made UmiGo their digital home. Whether you\'re catching up with family, playing games with friends, or meeting new people, UmiGo makes it easy and fun.',
    joinButton: 'Join UmiGo',
  },
  testimonials: {
    tag: 'Testimonials',
    title: 'What our users',
    titleLine2: 'are saying',
    user1: 'María Contreras',
    user1Since: 'User since 2024',
    user1Text: 'UmiGo has completely changed how I stay in touch with my family in Mexico. The voice chat quality is amazing, and my kids love the mini games!',
    user2: 'Juan Silva',
    user2Since: 'User since 2023',
    user2Text: 'The best social app for Latin America! I\'ve made so many friends from different countries. The family spaces feature is perfect for organizing reunions.',
    user3: 'Ana Rodríguez',
    user3Location: 'Buenos Aires, Argentina',
    user4: 'Carlos Mendoza',
    user4Location: 'Lima, Peru',
    user4Text: 'I use UmiGo every day to connect with my gaming squad. The video quality is incredible and we never experience lag!',
    user5: 'Laura Gómez',
    user5Text: 'Perfect for staying connected with family across borders. Love it!',
    user6: 'Diego Pérez',
    user6Text: 'The mini games are so addictive! My whole family plays together every weekend.',
  },
  cta: {
    tag: 'Available Now',
    imageTitle1: 'Download',
    imageTitle2: 'UmiGo',
    imageTitle3: 'Today',
    title: 'Start your',
    titleLine2: 'social adventure',
    description: 'Join millions of users across Latin America. Download UmiGo now and start connecting with friends and family in seconds. It\'s free, fast, and fun!',
    downloadButton: 'Get UmiGo!',
  },
  footer: {
    title: 'Stay',
    titleLine2: 'Connected',
    subtitle: 'Connect with us directly if you are influencer, potential partner or running an agency',
    emailPlaceholder: 'your@email.com',
    subscribeButton: 'Connect',
    subscribing: 'Connecting...',
    successMessage: 'Successfully connected!',
    errorMessage: 'Something went wrong. Please try again.',
    linksTitle: 'Links',
    features: 'Features',
    games: 'Games',
    family: 'Family',
    download: 'Download',
    contactTitle: 'Contact',
    officeTitle: 'Office',
    officeAddress: 'Av. Paseo de la Reforma 222\nCiudad de México, CDMX 06600\nMexico',
    privacy: 'Privacy',
    terms: 'Terms',
    copyright: '© 2025 UmiGo. All rights reserved.',
  },
};

export default common;
